import {BaseApi} from '@/api/base.api';
import {HomePartner} from '@/models/home-partner';

export class HomePartnersApi extends BaseApi<HomePartner> {
  constructor() {
    super('platform-partners');
  }
}
